import '@babel/polyfill';
import 'isomorphic-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import createStore from './redux/create';
import Software from './software';
import SidePanel from './side-panel';

import { LOCALE } from 'utils/environment';

const store = createStore();

const softwareFeed = document.getElementById('software-feed');
const sideMenu = document.getElementsByClassName('_Skins_SideMenu');

ReactDOM.render(
  <Provider store={store}>
    <Software />
  </Provider>,
  softwareFeed
);

if (LOCALE === 'ja-jp' && sideMenu[0]) {
  ReactDOM.render(
    <Provider store={store}>
      <SidePanel defaultItems={sideMenu[0].innerHTML} />
    </Provider>,
    sideMenu[0]
  );
}
